import { createSelector } from "reselect";
import { getStaffLoginState } from "./getStaffLoginState";

export const getLocationId = createSelector(getStaffLoginState, (staffLogin) =>
    staffLogin.status === "authenticated" ? staffLogin.locationId : null
);
